
/**
 * 菜单
 * wangj
 */


const SgiStepsEO = function () {

    return {

        // ctlH: "",
        // ctlW: "",
        desId: "EP_EO_UI_3015",
        // rSC:"rnt_SC_webTest_0001",//下拉窗列表值在标准代码中的id
        current: 0,//指定当前步骤，从 0 开始记数 //数字类型，不能是字符串类型！
        direction: "horizontal",
        c: '',//
        ctlN: "步骤",
        cId: '',//组件编号
        // sc:'',//语义代码
        n: "步骤",
        // t: "text",
        te: "我是步骤组件x",

    }

}

export { SgiStepsEO };
export default SgiStepsEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiStepsEO.js